export const T_TO_PASTE_CODES  = '^ скопируйте коды сюды ^';
export const T_LIST_NOT_UNIQ   = 'ОШИБКА: В списке есть дубликаты';
export const T_CTRL_P          = 'Ctrl+P: Печать';

